<template>
  <div>
    <loader v-show="!currentScreen.kostil.isViewReady"></loader>
    <div v-show="currentScreen.kostil.isViewReady">
      <h3>Выберите способ списания платежей:</h3>
      <div v-if="!iphone">
        <label for="selectBindPayment_b2pBindings" class="instRadioInput">
          <div class="fakeWrap" v-bind:class="{active: selectBindPayment === 'b2pBindings'}">
            <input type="radio" v-model="selectBindPayment" :value="'b2pBindings'" id="selectBindPayment_b2pBindings">
          </div>
          <span>Привязать счет(СБП)</span>
        </label>
        <p v-show="selectBindPayment === 'b2pBindings'">Для привязки счета, нажмите "подтвердить". Вы перейдете на экран
          привязки платежных средств.</p>
      </div>


      <div >
<!--      <div v-if="iphone">-->
        <label for="selectBindPayment_tkCard" class="instRadioInput">
          <div class="fakeWrap" v-bind:class="{active: selectBindPayment === 'tkCard'}">
            <input type="radio" v-model="selectBindPayment" :value="'tkCard'" id="selectBindPayment_tkCard">
          </div>
          <span>Привязать карту</span>
        </label>
        <div v-show="selectBindPayment === 'tkCard'" id="selectorGet">
          <div id="issetCard">
            <div v-if="tinkoffE2C.length > 0">
              <h3>Выберите свою карту</h3>
              <div id="issetCardLayout">
                <div
                    v-for="(item,index) in tinkoffE2C"
                    :key="index"
                    class="item"
                    v-bind:class="{selected:item.cardId === tinkoffE2C_cardSelected.cardId}"
                >
                  <label :for="'card_' + index">
                    <input type="radio" v-model="tinkoffE2C_cardSelected" :value="item" :id="'card_' + index">
                    <div class="cardView">
                      <img svg-inline :src=item.cardType alt="" class="falseSvg">
                      <span>{{ item.pan }}</span>
                    </div>

                  </label>
                </div>
              </div>
            </div>
            <div class="item" v-on:click="addTinkoffE2C">
              <label for="">
                <span></span>
                <span>Добавить новую карту</span>
              </label>
            </div>
          </div>

          <iframe id="tkFrame" :src="addTinkoffE2CURL" frameborder="0" v-if="addTinkoffE2CURL.length > 0"
                  style="width: 100%;height: 600px"></iframe>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import {mapState} from "vuex";
import palantir from "@/gavnoCode/palantir";
// import { best2pay_bindPayment } from '@/store/instStepForm'

export default {
  name: "instBindigPayment",
  data() {
    return {
      iphone: false,
      // selectBindPayment: '',
      tinkoffE2C: [],
      cardIcon: {
        masterCard: require('@/assets/vector/cardTypesLogo/Mastercard.svg'),
        MIR: require('@/assets/vector/cardTypesLogo/MIR.svg'),
        visa: require('@/assets/vector/cardTypesLogo/visa.svg'),
        AmericanExpress: require('@/assets/vector/cardTypesLogo/amex.svg'),
        JCB: require('@/assets/vector/cardTypesLogo/JCB.svg'),
        International: require('@/assets/vector/cardTypesLogo/ICS.svg'),
        DinersClub: require('@/assets/vector/cardTypesLogo/dinersClub.svg'),
        Maestro: require('@/assets/vector/cardTypesLogo/maestro.svg'),
        Discover: require('@/assets/vector/cardTypesLogo/discover.svg'),
        UEK: require('@/assets/vector/cardTypesLogo/Mastercard.svg'),
        chinaUnionPay: require('@/assets/vector/cardTypesLogo/chinaUnionPay.svg')
      },
      addTinkoffE2CURL: '',
    }
  },
  components: {
    loader: () => import('@/views/pdlloan/uiLoader'),
  },
  watch: {
    async selectBindPayment(newValue) {
      if (newValue === 'tkCard') {
        await this.getTinkoffE2C();
      }
    },
    addTinkoffE2CURL(newValue) {
      if (newValue.length > 0) {
        this.tryCathUpdateFromTinkof();
      }
    },
  },
  computed: {
    ...mapState({
      demandState: state => state.instForm.demandState,
      currentScreen: state => state.instForm.inst_CurrentStepForm,
      vuexCardSelected: state => state.Form.sendData.tinkoffE2C_cardSelected,
      vuexSelectBindPayment: state => state.Form.sendData.selectBindPayment,
    }),
    selectBindPayment: {
      get() {
        return this.vuexSelectBindPayment;
      },
      set(newValue) {
        this.$store.dispatch('saveSendData', {
          target: 'selectBindPayment',
          value: newValue
        });
      }
    },
    tinkoffE2C_cardSelected: {
      get() {
        return this.vuexCardSelected;
      },
      set(newValue) {
        this.$external.traceInput({
          action: 165,
          refs: 'tinkoffE2C_cardSelected',
          value: newValue
        });
        this.$store.dispatch('saveSendData', {
          target: 'tinkoffE2C_cardSelected',
          value: newValue
        });
      }
    },
  },
  methods: {
    tryCathUpdateFromTinkof() {
      if (this.addTinkoffE2CURL.length > 0) {
        this.getTinkoffE2C().then(() => {
          setTimeout(() => {
            this.tryCathUpdateFromTinkof();
          }, 3000);
        })
      }
    },
    addTinkoffE2C() {
      this.$axios({
        method: 'post',
        url: process.env.VUE_APP_URL_TINKOF,
        data: {
          action: 'addTinkoffE2C',
          clientId: this.demandState.Client_Id,
          session_id: this.$myApi.sessionId(),
        }
      }).then((res) => {
        this.addTinkoffE2CURL = res.data.paymentURL;
        setTimeout(() => {
          document.getElementById('tkFrame').scrollIntoView({
            behavior: 'smooth',
          });
        }, 300)
      }).catch((res) => console.log(res));
    },
    cardTypeIdentify(value) {
      let out = ''
      let deep = value.slice(1, 2)
      switch (value.slice(0, 1)) {
        case '2': {
          out = this.cardIcon.MIR
        }
          break;
        case '3': {
          if (deep === '0' || deep === '6' || deep === '8') {
            out = this.cardIcon.DinersClub
          } else if (deep === '1' || deep === '5') {
            out = this.cardIcon.International
          } else if (deep === '4' || deep === '7') {
            out = this.cardIcon.AmericanExpress
          }
        }
          break;
        case '4': {
          out = this.cardIcon.visa
        }
          break;
        case '5': {
          if (deep === '0' || deep === '6' || deep === '7' || deep === '8') {
            out = this.cardIcon.Maestro
          } else if (deep === '1' || deep === '2' || deep === '3' || deep === '4' || deep === '5') {
            out = this.cardIcon.masterCard
          }
        }
          break;
        case '6': {
          if (deep === '0') {
            out = this.cardIcon.Discover
          } else if (deep === '2') {
            out = this.cardIcon.chinaUnionPay
          } else if (deep === '3' || deep === '7') {
            out = this.cardIcon.Maestro
          }
        }
          break;
        case '7': {
          out = this.cardIcon.UEK
        }
          break;
        default:
          out = ''
      }
      // out = this.cardIcon.Discover
      return out
    },
    getTinkoffE2C() {
      return new Promise((resolve => {
        this.$axios({
          method: 'post',
          url: process.env.VUE_APP_URL_TINKOF,
          data: {
            action: 'getTinkoffE2C',
            clientId: this.demandState.Client_Id,
            session_id: this.$myApi.sessionId(),
          }
        }).then((res) => {
          let tempCountCard = this.tinkoffE2C.length;
          this.tinkoffE2C = res.data.cardList;
          for (let i = 0; i < this.tinkoffE2C.length; i++) {
            let firstFour = this.tinkoffE2C[i].pan.slice(0, 4)
            this.tinkoffE2C[i]['cardType'] = this.cardTypeIdentify(firstFour);
          }
          if (tempCountCard !== this.tinkoffE2C.length && this.addTinkoffE2CURL.length > 0) {
            this.addTinkoffE2CURL = '';
            document.getElementById('issetCard').scrollIntoView({
              behavior: 'smooth',
            });
          }
        }).catch((res) => console.log(res)).finally(() => resolve());
      }));
    },
  },
  mounted() {
    const deviceIphone =navigator.platform.toString().toUpperCase() === 'iPhone'.toUpperCase();
    if (deviceIphone) {
      // const randAb = localStorage.getItem('abiphonetbank') === null
      //                 ? Math.floor(Math.random() * 2)
      //                 : localStorage.getItem('abiphonetbank') === '0' || localStorage.getItem('abiphonetbank') === '1'
      //                     ? localStorage.getItem('abiphonetbank')
      //                     : Math.floor(Math.random() * 2);
      // localStorage.setItem('abiphonetbank', randAb);
      const randAb = Math.floor(Math.random() * 2);
      palantir.trackAction(228, randAb);
      this.iphone = randAb === 1;
    }
  }
}
</script>

<style scoped>

.instRadioInput{margin-top: 10vw;}
#payLayout {
  width: 100%
}

.item {
  border: 1px solid transparent;
  border-radius: 9px;
  box-shadow: 0 4px 4px #00000040;
  transition: 0.3s ease-out;
  cursor: pointer;
  margin-bottom: 2.94vw
}

.item:hover, .item.selected {
  background: rgba(67, 172, 52, 0.25);
  border: 1px solid #43AC34
}

.item label {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.itemElected {
  border: 1px solid transparent;
  border-radius: 9px;
  box-shadow: 0 4px 4px #00000040;
  transition: 0.3s ease-out;
  cursor: pointer;
  margin-bottom: 2.94vw
}

.itemElected:hover, .itemElected.selected {
  background: rgba(67, 172, 52, 0.25);
  border: 1px solid #43AC34
}

.itemElected label {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.itemElected label img {
  width: 58.82vw;
  height: 10.59vw
}

.cardView {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;
  height: 100%;
  width: 62vw
}

.cardView img {
  width: 22.06vw;
  height: 17.35vw
}

#selectorSet, #issetCardLayout, #selectorGet {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}

#selectorSet .item, #selectorGet .item {
  width: 90.88vw;
  height: 47.06vw;
}

#selectorSet .itemElected, #selectorGet .itemElected {
  width: 90.88vw;
  height: 47.06vw;
}

#selectorSet .item svg {
  width: 61.76vw;
  height: 35.29vw;
  outline: none;
}

#selectorSet .itemElected svg {
  width: 61.76vw;
  height: 35.29vw;
  outline: none;
}

#bankElected {
  display: flex;
  flex-wrap: wrap
}

#bankName {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap
}

#bankName .item {
  height: auto;
  padding: 4.41vw 0
}

#bankElected .itemElected {
  height: auto;
  padding: 4.41vw 0
}

#bankName .item span {
  width: 76.47vw
}

#bankElected .itemElected span {
  width: 76.47vw
}

@media (min-width: 760px) {
  .instRadioInput{margin-top: 10px;}
  #selectorSet, #issetCardLayout, #selectorGet {
    width: 51.61vw;
    flex-direction: row;
  }

  #selectorSet .item, #selectorGet .item {
    width: 24.92vw;
    height: 12.90vw;
  }

  #selectorSet .itemElected, #selectorGet .itemElected {
    width: 24.92vw;
    height: 12.90vw;
  }

  #selectorSet .item svg {
    width: 16.94vw;
    height: 9.68vw
  }

  #selectorSet .itemElected svg {
    width: 16.94vw;
    height: 9.68vw
  }


  .item {
    box-shadow: 0 4px 4px #00000040;
    margin-bottom: 0.81vw
  }

  .item:hover, .item.selected {
  }

  .item label {

  }

  .itemElected {
    box-shadow: 0 4px 4px #00000040;
    margin-bottom: 0.81vw
  }

  .itemElected:hover, .itemElected.selected {
  }

  .itemElected label {
  }

  .itemElected label img {
    width: 16.13vw;
    height: 3.54vw
  }

  .cardView {
    width: 16.27vw
  }

  .cardView img {
    width: 75px;
    height: 59px
  }

  #bankName {
  }

  #bankName .item {
    padding: 15px 0;
    height: auto
  }

  #bankElected .itemElected {
    padding: 15px 0;
    height: auto
  }

  #bankName .item span {
    width: 260px
  }

  #bankElected .itemElected span {
    width: 260px
  }
}

@media (min-width: 1240px) {
  #selectorSet, #issetCardLayout {
    width: 640px
  }

  #selectorGet {
    width: 100%
  }

  #selectorSet .itemElected, #selectorGet .itemElected {
    width: 211px;
    height: 65px;
  }

  #selectorSet .item, #selectorGet .item {
    width: 309px;
    height: 160px;
  }

  #selectorSet .item svg {
    width: 210px;
    height: 120px
  }

  #selectorSet .itemElected svg {
    width: 210px;
    height: 120px
  }


  .item {
    box-shadow: 0 4px 4px #00000040;
    margin-bottom: 10px
  }

  .item:hover, .item.selected {
  }

  .item label {
  }

  .itemElected {
    box-shadow: 0 4px 4px #00000040;
    margin-bottom: 10px
  }

  .itemElected:hover, .itemElected.selected {
  }

  .itemElected label {
  }

  .itemElected label img {
    width: 150px;
    height: 60px
  }

  .itemElected:nth-child(1) label img {
    height: 31px;
    padding-top: 10px
  }

  .itemElected:nth-child(2) label img {
    height: 31px;
    padding-bottom: 4px
  }

  .itemElected:nth-child(3) label img {
    height: 31px
  }

  .cardView {
    width: 196px
  }

  .cardView img {
    width: 75px;
    height: 59px
  }

  #bankName {
  }

  #bankName .item {
    padding: 15px 0;
    height: auto
  }

  #bankElected .itemElected {
    padding: 15px 0
  }

  #bankName .item span {
    width: 260px
  }

  #bankElected .itemElected span {
    width: 260px
  }
}
</style>